import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import TextareaButtonInterface from "~/operatorApplication/vue/dialogs/dialog/textarea/TextareaButtonInterface";
import {computed} from "vue";
import ButtonsListConfigButton
    from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/ButtonsListConfigButton.vue";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "TextareaButtons"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    buttons: {},
    left: { type: Boolean },
    showConfig: { type: Boolean },
    unpinAllButtons: { type: Boolean }
  },
  setup(__props: any) {

let props = __props;

let buttonsToDisplay = computed(() => {
    return props.buttons
        .filter(button => !!button.isRightSide === !props.left)
        .filter(button => !props.unpinAllButtons && (OperatorApplicationConfigInstance.isTextareaButtonPinned(button.id) || button.alwaysPinned))
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(buttonsToDisplay), (button) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(button.component), {
        key: button.id
      }))
    }), 128)),
    (__props.showConfig)
      ? (_openBlock(), _createBlock(ButtonsListConfigButton, {
          key: 0,
          buttons: __props.buttons,
          "hide-pin": __props.unpinAllButtons
        }, null, 8, ["buttons", "hide-pin"]))
      : _createCommentVNode("", true)
  ]))
}
}

})